import * as actionTypes from './actionTypes';

export const toggleLayerSettingsDropdown_legacy = (key) => {
    return {
        type: actionTypes.LAYERSETTINGS_TOGGLE_LEGACY,
        key: key
    };
};

export const initKryLayerslys_legacy = () => {
    return {
        type: actionTypes.INIT_LAYERSLYS_LEGACY
    };
};

export const getLayerslys_legacy = (data) => {
    return {
        type: actionTypes.GET_LAYERSLYS_LEGACY,
        data: data
    };
};

export const setLayerslys_legacy = (data) => {
    return {
        type: actionTypes.SET_LAYERSLYS_LEGACY,
        data: data
    };
};

export const getLayerslysFailed_legacy = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSLYS_FAILED_LEGACY,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};
export const kiesLayer_legacy = (key) => {
    return {
        type: actionTypes.KIES_LAYER_LEGACY,
        key: key
    };
};

export const initKryLayers_legacy = () => {
    return {
        type: actionTypes.INIT_LAYERSAKTIEF_LEGACY
    };
};

export const getLayers_legacy = (data) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_LEGACY,
        data: data
    };
};

export const setLayers_legacy = (data) => {
    return {
        type: actionTypes.SET_LAYERSAKTIEF_LEGACY,
        data: data
    };
};

export const getLayersFailed_legacy = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_LAYERSAKTIEF_FAILED_LEGACY,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const removeLayer_legacy = (key) => {
    return {
        type: actionTypes.REMOVE_LAYER_LEGACY,
        key: key
    };
};

export const changeLayertipe_legacy = (key, tipe, layerkey) => {
    return {
        type: actionTypes.CHANGE_LAYERTIPE_LEGACY,
        key: key,
        tipe: tipe,
        layerkey: layerkey
    };
};

export const changeLayerFilter_legacy = (key, tipe, nuwewaarde) => {
    return {
        type: actionTypes.CHANGE_LAYERFILTER_LEGACY,
        key: key,
        tipe: tipe,
        nuwewaarde: nuwewaarde
    };
};

export const setLayerEventListener_legacy = () => {
    return (getState) => {
        console.log(getState());
        var data = [];
        const newlayersmetadata = [getState().layersmetadata.data];;
        for (var layer of newlayersmetadata) {
            for (var tipe of layer.layertipes) {
                if (tipe.active && tipe.infooverlay) {
                    if (getState().layers.data.find(obj => obj.id === layer.key)) {
                        data.push(getState().layer.data);
                    }
                }
            }
        }
        return {
            type: actionTypes.SET_LAYER_EVENTLISTENER_LEGACY,
            data: data
        };
    }
};

export const bindEventlistener_legacy = (mustbind) => {
    return {
        type: actionTypes.BIND_EVENTLISTENER_LEGACY,
        mustbind: mustbind
    };
};

export const bindComponent_legacy = () => {
    return {
        type: actionTypes.BIND_COMPONENT_LEGACY
    };
};